<template>
  <v-container class="container-page">
    <v-card class="mt-0 transparent">
      <v-card-text class="px-0 py-0">

        <v-btn
          fixed
          bottom
          right
          fab
          class="mt-5 mr-2"
          dark
          :to="{ name: 'UserNew' }"
          color="accent"><v-icon>add</v-icon>
        </v-btn>

        <template>
          <v-tabs
            slider-color="accent"
            class="tabs-transparent"
          >
            <v-tab ripple :to="{name: 'Users', params: { group: 'administrator' } }">Administradores</v-tab>
            <v-tab ripple :to="{name: 'Users', params: { group: 'supervisor' } }">Supervisores</v-tab>
          </v-tabs>
          <v-card flat class="transparent content-tab">
            <loading v-if="loading > 0" class="absolute-center"></loading>

            <template v-else>
              <!-- <v-card class="transparent elevation-0" v-if="users && users.data.length > 0"> -->
              <v-card class="transparent elevation-0">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm5>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-card-title>
                <v-data-table
                  :pagination.sync="pagination"
                  :headers="headers"
                  :items="users"
                  :search="search"
                  :rows-per-page-items="[25, 50, 100]"
                  rows-per-page-text="Mostrar por página"
                  class="table-transparent table-sticky table-clicked"
                >
                  <template v-slot:items="props" class="transparent">
                    <tr >
                      <td @click="selectUser(props.item.id)">{{ props.item.name }}</td>
                      <td @click="selectUser(props.item.id)">{{ props.item.email }}</td>
                      <td @click="selectUser(props.item.id)">{{ $d(props.item.insertedAt.toDate(), 'long') }}</td>
                    </tr>
                  </template>
                  <template v-slot:pageText="props" >
                    Exibindo de {{ props.pageStart }} a {{ props.pageStop }} no total de {{ props.itemsLength }}
                  </template>
                  <template v-slot:no-results>
                    <!-- <empty-state class="mt-2" size="75px" icon="find_in_page">
                      Sua busca por "{{ search }}" não possui resultados
                    </empty-state> -->
                  </template>

                </v-data-table>
              </v-card>

              <!-- <empty-state v-else size="75px" icon="supervisor_account" style="margin-top: -50px;" class="absolute-center">
                Não há usuários cadastrados com esse perfil <br>

                <v-btn v-if="!activedTabMediator" color="accent" depressed small :to="{ name: 'User' }">Cadastrar usuário</v-btn>

                <v-btn v-else color="accent" depressed small :to="{ name: 'User' }">Cadastrar mediador</v-btn>
              </empty-state> -->

            </template>

          </v-card>
        </template>
      <transition name="slide" mode="out-in" appear>
        <router-view></router-view>
      </transition>

      </v-card-text>
    </v-card>

    <!-- <modal
      :show="showModalDelete"
      btnPrimaryLabel="Sim, quero excluir"
      @close="closeConfirm"
      @submit="confirmRemove"
      :toolbar="true"
      >
      <h2 slot="title" class="title">Confirmação</h2>
      <div slot="content">
        <p class="title mt-4">Deseja realmente excluir o usuario "{{userToDelete.name}}" ?</p>
      </div>
    </modal> -->

  </v-container>
</template>

<script>
  // import Modal from '@/components/ui/Modal'
  // import EmptyState from '@/components/ui/EmptyState'
  import SidebarContent from '@/components/ui/SidebarContent'
  import Loading from '@/components/ui/Loading'
  import { mapGetters } from 'vuex'
  // import * as gql from '@/graphql/users'
  // import mixin from './mixin'

  export default {
    name: 'Users',
    components: {
      // Modal,
      // EmptyState,
      SidebarContent,
      Loading
    },
    // mixins: [ mixin ],
    data: () => ({
      search: '',
      headers: [
        { text: 'Nome', value: 'name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Data de criação', value: 'metadata.creationTime', sortable: false }
      ],
      pagination: {
        sortBy: 'insertedAt',
        descending: true
      },
      userToDelete: {},
      showModalDelete: false
    }),
    computed: {
      ...mapGetters({
        users: 'users/list',
        loading: 'users/loading'
      })
    },
    methods: {
      selectUser (id) {
        // this.$router.push({ name: 'Users', params: { userId: id } })
      },
      closeConfirm () {
        this.userToDelete = {}
        this.showModalDelete = false
      },
      removeUser (user) {
        this.userToDelete = user
        this.showModalDelete = true
      },
      confirmRemove () {
        let message = 'Usuário removido com sucesso'
        this.closeConfirm()
        // this.$root.$emit('snackbar', {show: true, color: 'success', text: message})
      },
      changeRouter () {
        this.$store.dispatch('users/getList', this.$route.params.group)
      }
    },
    beforeMount () {
      this.$store.dispatch('users/getList', this.$route.params.group)
    },
    watch: {
      '$route': 'changeRouter'
    },
  }
</script>

<style lang="sass">
  .content-tab
    height: calc(100vh - 50px) !important
</style>
